import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout/layout'

const _import = require('./_import_' + process.env.NODE_ENV)
// in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading

const Home = _import('dashboard/home.vue')
const GroupTalk = _import('groupTalk/index.vue')
const AlarmLog = _import('alarmLog/index.vue')
const PhotoManage = _import('photoManage/index.vue')
Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    component: layout,
    redirect: '/home',
    children: [
      {path: '/home', component: Home, name: '首页' },
      {path: '/groupTalk', component: GroupTalk, name: '群组通话' },
      {path: '/alarmLog', component: AlarmLog, name: '报警记录' },
      {path: '/photoManage', component: PhotoManage, name: '照片管理' },
    ]
  }
]

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js